import { VisuallyHidden } from "@radix-ui/react-visually-hidden";
import { useTranslation } from "react-i18next";

import { useUnsavedChanges } from "~/providers/unsaved-changes-provider";
import { useModifierGroupStore } from "~/stores/use-modifier-group-store";
import { Button } from "../ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { ScrollArea } from "../ui/scroll-area";
import ModifierGroupForm from "./modifier-group-form";

export default function ModifierGroupDialog() {
  const {
    modifierGroupFormOpen,
    currentModifierGroup,
    setCurrentModifierGroup,
    setModifierGroupFormOpen,
  } = useModifierGroupStore();

  const { checkUnsavedChanges } = useUnsavedChanges();

  const { t } = useTranslation("common");
  const handleDialog = (open: boolean, force?: boolean) => {
    if (open === false) {
      if (force !== true) {
        const result = checkUnsavedChanges();
        if (result === true) return;
      }
      setCurrentModifierGroup(undefined);
    }
    setModifierGroupFormOpen(open);
  };

  return (
    <Dialog open={modifierGroupFormOpen} onOpenChange={handleDialog}>
      <DialogContent className="max-w-2xl w-full">
        <DialogHeader>
          <DialogTitle>{t("Product_product")}</DialogTitle>
          <VisuallyHidden>
            <DialogDescription></DialogDescription>
          </VisuallyHidden>
        </DialogHeader>
        <div className="max-h-[80vh] p-4 overflow-auto small-scrollbar">
          <ModifierGroupForm
            onClose={(force) => handleDialog(false, force)}
            modifierGroup={currentModifierGroup}
          />
        </div>
        <DialogFooter>
          <Button type="submit" form="modifier-group-form" variant="success">
            {currentModifierGroup ? t("update") : t("create")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
